module.exports = __webpack_public_path__ + "img/204.eb85e7e7.jpg";